import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";

export default function Invoices() {
  const [catalog, setCatalog] = useState([]);
  const [history, setHistory] = useState([]);

  const load = useCallback(async () => {
    const [c, h] = await Promise.all([api.get("/payments/catalog"), api.get("/payments/history")]);
    setCatalog(c.data); setHistory(h.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const pay = async (lookup_key) => {
    try {
      const r = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Checkout failed"); }
  };

  const groups = [
    { key: "volume", label: "Record Volume Fees" },
    { key: "hourly", label: "Hourly & Flat Professional Services" },
    { key: "membership", label: "Monthly Memberships" },
  ];

  return (
    <div className="fade-in-up">
      <div className="mb-8"><div className="text-caption text-[#B91C1C] mb-2">INVOICING</div><h1 className="font-serif text-3xl font-bold text-[#0A192F]">Invoices & Payments</h1>
        <p className="text-slate-600 mt-2 text-sm">Every engagement begins with a <span className="font-semibold text-[#0A192F]">free 15-minute confidential consultation</span>.</p>
      </div>
      {groups.map((g) => {
        const items = catalog.filter((p) => p.group === g.key);
        if (!items.length) return null;
        return (
          <div key={g.key} className="mb-10">
            <h2 className="font-serif text-xl font-bold text-[#0A192F] mb-4" data-testid={`group-${g.key}`}>{g.label}</h2>
            <div className="card-federal divide-y divide-slate-100">
              {items.map((p) => (
                <div key={p.lookup_key} className="flex items-center justify-between px-5 py-3.5" data-testid={`sku-${p.lookup_key}`}>
                  <div className="text-slate-800 text-sm">{p.name}</div>
                  <div className="flex items-center gap-4">
                    <span className="font-mono text-[#0A192F]">${(p.amount/100).toLocaleString()}{p.kind === "subscription" ? "/mo" : ""}</span>
                    <button onClick={() => pay(p.lookup_key)} className="btn-crimson px-4 py-2 text-[11px] uppercase tracking-widest inline-flex items-center gap-1.5" data-testid={`pay-${p.lookup_key}`}><CreditCard className="w-3.5 h-3.5" /> {p.kind === "subscription" ? "Subscribe" : "Pay"}</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <div className="card-federal">
        <div className="p-6 border-b border-slate-200"><h2 className="font-serif font-bold text-lg text-[#0A192F]">Payment History</h2></div>
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-6 py-3 text-caption">Session</th>
            <th className="text-left px-6 py-3 text-caption">Service</th>
            <th className="text-left px-6 py-3 text-caption">Amount</th>
            <th className="text-left px-6 py-3 text-caption">Status</th>
          </tr></thead>
          <tbody>
            {history.length === 0 && <tr><td colSpan={4} className="text-center py-8 text-slate-500">No payments yet.</td></tr>}
            {history.map((h) => (
              <tr key={h.session_id} className="border-t border-slate-100">
                <td className="px-6 py-3 font-mono text-xs">{h.session_id.slice(0,24)}…</td>
                <td className="px-6 py-3">{h.lookup_key}</td>
                <td className="px-6 py-3 font-mono">${(h.amount/100).toFixed(2)}</td>
                <td className="px-6 py-3"><span className={`badge-federal ${h.payment_status === "paid" ? "!border-[#15803D] !text-[#15803D]" : ""}`}>{h.payment_status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
